import React from 'react';
import { Lightning, TrendUp, Clock } from 'phosphor-react';

/**
 * Trade Type Badge Component
 * Displays a small, subtle badge for trade classification
 */
export default function TradeTypeBadge({ tradeType, size = 'sm' }) {
  if (!tradeType) return null;

  const config = {
    scalp: {
      label: 'SCALP',
      icon: Lightning,
      bgColor: 'bg-yellow-500/10',
      borderColor: 'border-yellow-500/20',
      textColor: 'text-yellow-400',
      iconColor: 'text-yellow-400'
    },
    day_trade: {
      label: 'DAY',
      icon: TrendUp,
      bgColor: 'bg-[#00E676]/10',
      borderColor: 'border-[#00E676]/20',
      textColor: 'text-[#00E676]',
      iconColor: 'text-[#00E676]'
    },
    swing_trade: {
      label: 'SWING',
      icon: Clock,
      bgColor: 'bg-purple-500/10',
      borderColor: 'border-purple-500/20',
      textColor: 'text-purple-400',
      iconColor: 'text-purple-400'
    }
  };

  const typeConfig = config[tradeType];
  if (!typeConfig) return null;

  const Icon = typeConfig.icon;
  
  const sizeClasses = {
    xs: 'px-1.5 py-0.5 text-[9px] gap-0.5',
    sm: 'px-2 py-0.5 text-[10px] gap-1',
    md: 'px-2.5 py-1 text-xs gap-1.5'
  };

  const iconSizes = {
    xs: 10,
    sm: 12,
    md: 14
  };

  return (
    <span 
      className={`
        inline-flex items-center rounded-sm font-semibold tracking-wide
        ${typeConfig.bgColor} ${typeConfig.borderColor} ${typeConfig.textColor}
        border ${sizeClasses[size]}
        transition-colors
      `}
    >
      <Icon size={iconSizes[size]} weight="bold" className={typeConfig.iconColor} />
      {typeConfig.label}
    </span>
  );
}
